import { useQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { businessHoursKeys } from '@petseo/shared';

export const useBusinessHours = (serviceVendorId: ServiceVendorId) => {
  return useQuery({
    queryKey: businessHoursKeys.forVendor(serviceVendorId),
    queryFn: async () => {
      const response = await serviceVendorsClient.getBusinessHoursEndpoint(serviceVendorId);
      return response.data;
    },
    select: (data) => data.businessHours ?? [],
    enabled: !!serviceVendorId,
  });
};
